import { useEffect } from 'react';

import { Outlet, Navigate, useNavigate } from 'react-router';

import { useSelector } from 'react-redux';
import { fetchCheckAuthUser, selectIsAuth } from '@/store/slices/authSlice';
import { fetchCurrentCompany } from '@/store/slices/companySlice';
import { RootState, useAppDispatch } from '@/store/store';

import Header from '@/components/header';
import Tabs from '@/components/tabs';
import Spinner from '@/components/spinner';

export const Layout = () => {
  const isAuth = useSelector(selectIsAuth);
  const loading = useSelector((state: RootState) => state.auth.loading);
  const currentCompany = useSelector(
    (state: RootState) => state.company.currentCompany
  );
  const hasIntegration =
    currentCompany?.hasIntegrationWithConnectedStatus ?? true;

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchCheckAuthUser());
    dispatch(fetchCurrentCompany());
  }, [dispatch]);

  useEffect(() => {
    if (!hasIntegration) {
      navigate('/cases', { replace: true });
    }
  }, [hasIntegration, navigate]);

  if (loading) return <Spinner />;

  return (
    <>
      <Header />
      <Tabs />
      {isAuth ? <Outlet /> : <Navigate to="/login" replace />}
    </>
  );
};
